// extracted by mini-css-extract-plugin
export default {"ProfilePayBalance":"v9JvVe9nke","Intro":"j6niZuUSMH","Card":"M5ogOfh9lO","CardDetails":"R72ZdsJKau","Row":"xgUqbUneMa"};